import { EDUGATE_API_URL } from '../config/serviceConfig'

const KEY = 'ybg_local_login'

/** 把地址里的本机登录请求号记入当前标签页，再从地址栏去掉。 */
export function captureYbgLocalLogin() {
  if (typeof window === 'undefined') return ''
  const params = new URLSearchParams(window.location.search)
  const id = params.get('ybg_local_login')
  if (!id) return sessionStorage.getItem(KEY) || ''
  sessionStorage.setItem(KEY, id)
  params.delete('ybg_local_login')
  const next = params.toString()
  const url = window.location.pathname + (next ? `?${next}` : '') + window.location.hash
  window.history.replaceState({}, document.title, url)
  return id
}

export function getPendingLocalLogin() {
  if (typeof window === 'undefined') return ''
  return sessionStorage.getItem(KEY) || ''
}

export function clearPendingLocalLogin() {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(KEY)
}

const inflight = new Map()

/** 统一认证回调后，用云端会话令牌换本机回跳地址。同一标签页只发一次。 */
export function completeLocalLogin(provider, token) {
  const requestId = getPendingLocalLogin()
  if (!requestId) return Promise.resolve('')
  const key = `${requestId}:${provider}:${token}`
  const existing = inflight.get(key)
  if (existing) return existing
  const promise = requestLocalRedirect(requestId, provider, token).finally(() => {
    inflight.delete(key)
  })
  inflight.set(key, promise)
  return promise
}

async function requestLocalRedirect(requestId, provider, token) {
  const response = await fetch(`${EDUGATE_API_URL}/api/local-auth/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ request_id: requestId, provider, token }),
  })
  const data = await response.json().catch(() => ({}))
  const redirectURL = data?.data?.local_redirect_url
  if (!response.ok || !redirectURL) {
    clearPendingLocalLogin()
    throw new Error(data.message || '本机登录回跳失败')
  }
  clearPendingLocalLogin()
  return redirectURL
}

captureYbgLocalLogin()
